import {Injectable} from "@angular/core";
import {MatSnackBar, MatSnackBarConfig} from "@angular/material/snack-bar";

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  constructor(private _snackBar: MatSnackBar) {
  }

  public log(message: string) {
    this._snackBar.open(message, 'Закрыть', {
      horizontalPosition: "center",
      verticalPosition: "top",
    })
  }

  public logInfo(message: string) {
    this._snackBar.open(message, 'Закрыть', {
      horizontalPosition: "center",
      verticalPosition: "top",
    })
  }

  public showSuccess(message: string) {
    this._snackBar.open(message, 'Закрыть', {
      horizontalPosition: "center",
      verticalPosition: "top",
      duration: 5000,
      panelClass: ['success-snackbar']
    })
  }

  public showError(message: string) {
    this._snackBar.open(message, 'Закрыть', {
      horizontalPosition: "center",
      verticalPosition: "top",
      duration: 7000,
      panelClass: ['error-snackbar']
    })
  }

  public showWarning(message: string) {
    this._snackBar.open(message, 'Закрыть', {
      horizontalPosition: "center",
      verticalPosition: "top",
      duration: 6000,
      panelClass: ['warning-snackbar']
    })
  }
}
